import widgetsDataService from '../services/widgetsDataService.js'

const coinInfoTable = {
    async updateDynamicsData() {
        let widgets = $('.widget-coin-info-table-wrapper');

        for (let i = 0; i < widgets.length; i++) {
            let data = $(widgets[i]).data();
            let widgetData = await widgetsDataService.fetchWidgetDataAsync('getCoinInfoTableData', data.coinId, data.currency);
    
            widgetsDataService.updateDataOnPage(`.widget-coin-info-table-wrapper.${data.coinId}`, widgetData);
        }
    }
}

export default coinInfoTable;